import React, { useCallback, useEffect, useMemo, useState } from 'react'
import UserService from '../../../services/user/UserService'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import { Button, Modal, Spinner } from 'react-bootstrap'
import NonlalinDisposisi from '../../../utilities/nonlalin/NonlalinDisposisi'
import PbUmkuService from '../../../services/pbumku/PbumkuService'
import { AsyncPaginate } from 'react-select-async-paginate'
import { formatDateString, getCurrentDateFormatted, romanNum } from '../../../utilities/Utils'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalBast = ({ showAddBast, handleCloseAddBast, dataDisposisi, datappm, reloadList, isEdit }) => {
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    let userService = useMemo(() => new UserService(), [])
    let nonLalinService = useMemo(() => new NonlalinService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const fetchAllData = useCallback(async () => {
        try {
            const resBast = await nonLalinService.getNonlalinBast(datappm.nomorAju, dataDisposisi.noTugas)

            const resPenerima = await userService.getPegawaiById(resBast.data.nipPenerimaContoh)
            setValuePenerimaContohOpt(resPenerima.data)

            const resPetugasLab = await userService.getPegawaiById(resBast.data.nipPetugasLab)
            setValuePetugasLabOpt(resPetugasLab.data)

            setValueTanggalBast(formatDateString(resBast.data.tglBast))
        } catch (error) {

        }
    }, [nonLalinService, userService, datappm, dataDisposisi])

    useEffect(() => {
        if (!datappm) return
        fetchAllData()
    }, [fetchAllData, datappm])

    const [valuePenerimaContohOpt, setValuePenerimaContohOpt] = useState(null)
    async function loadOptionPenerimaContoh(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem("kdUnit"), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangePenerimaContoh = e => {
        setValuePenerimaContohOpt(e)
    }

    const [valuePetugasLabOpt, setValuePetugasLabOpt] = useState(null)
    async function loadOptionPetugasLab(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem("kdUnit"), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            addition: {
                page: page + 1
            }
        }
    }
    const onChangePetugasLab = e => {
        setValuePetugasLabOpt(e)
    }

    const [valueTanggalBast, setValueTanggalBast] = useState(null)
    const onChangeTanggalbast = e => {
        setValueTanggalBast(e.target.value)
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmBast, setShowConfirmBast] = useState(false)
    const handleCloseConfirmBast = () => setShowConfirmBast(false)
    const [showBastSuccess, setShowBastSuccess] = useState(false)
    const [showBastFailed, setShowBastFailed] = useState(false)
    const [rowBast, setRowBast] = useState(null)

    const SaveBast = (dataDisposisi) => {
        setShowConfirmBast(true)
        setRowBast(dataDisposisi)
    }

    const handleClickSimpan = async () => {
        setLoadingSave(true)
        try {
            const respNomor = await pbumkuService.ambilNomorService("NLL_BAST", datappm.kodeUpt, currentYear, localStorage.getItem('username'))
            let noSuratTugas = respNomor.data.uraianPusat + '/' + datappm.kodeUpt + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + respNomor.data.nomorUrut
            let jsonBast = { ...rowBast, noTugas: noSuratTugas, tglTugas: getCurrentDateFormatted(), createdBy: localStorage.getItem("userId"), createdAt: new Date() }
            const _resBast = await nonLalinService.saveNonlalinPenugasan(jsonBast)
            if (_resBast.data.kode === '200') {
                let jsonBast = {
                    nomorAju: datappm.nomorAju,
                    noTugas: noSuratTugas,
                    nipPenerimaContoh: valuePenerimaContohOpt.nip,
                    nmPenerimaContoh: valuePenerimaContohOpt.nama,
                    jabatanPenerimaContoh: valuePenerimaContohOpt.jabatan,
                    noregPenerimaContoh: valuePenerimaContohOpt.noReg,
                    nipPetugasLab: valuePetugasLabOpt.nip,
                    nmPetugasLab: valuePetugasLabOpt.nama,
                    jabatanPetugasLab: valuePetugasLabOpt.jabatan,
                    noregPetugasLab: valuePenerimaContohOpt.noReg,
                    tglBast: valueTanggalBast,
                    createdBy: localStorage.getItem("userId"),
                    createdDate: new Date()
                }
                // console.log(jsonBast)
                await nonLalinService.saveNonlalinBast(jsonBast)

                let jsonppm = { ...datappm, status: '021' }
                await nonLalinService.saveNonlalinHeader(jsonppm)

                setShowBastSuccess(true)
                setShowConfirmBast(false)
            } else {
                setShowBastFailed(true)
                setShowConfirmBast(false)
            }
        } catch (error) {
            setShowBastFailed(true)
            setShowConfirmBast(false)
        }
        setLoadingSave(false)
    }

    const handleClickBastSuccess = () => {
        setShowBastSuccess(false)
        // window.location.reload()
        reloadList(datappm.nomorAju)
    }

    const handleClickBastFailed = () => {
        setShowBastFailed(false)
    }

    return (
        <>
            <Modal
                show={showAddBast}
                onHide={handleCloseAddBast}
                backdrop='static'
                size='lg'
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <h5><NonlalinDisposisi idDisposisi={dataDisposisi.idDisposisi} /></h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} readOnly />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Penerima Contoh</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPenerimaContoh}
                                value={valuePenerimaContohOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePenerimaContoh}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Petugas Lab</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPetugasLab}
                                value={valuePetugasLabOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePetugasLab}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Tanggal BAST</label>
                        <div className="col-sm-8">
                            <input type="date" className="col-sm-4 form-control-sm" name="tglBast" value={valueTanggalBast} onChange={onChangeTanggalbast} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => SaveBast(dataDisposisi)}>Simpan</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseAddBast}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmBast &&
                <SweetAlert
                    title="Proses BAST?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmBast}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showBastSuccess &&
                <SweetAlert
                    title="Simpat BAST Berhasil"
                    success
                    onConfirm={handleClickBastSuccess}
                    btnSize="sm"
                />
            }
            {
                showBastFailed &&
                <SweetAlert
                    title="Simpan BAST Gagal"
                    danger
                    onConfirm={handleClickBastFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalBast